(() => {
  const enhance = () => {
    document.querySelectorAll('[data-cat-search] select[data-name="product_type"]').forEach(select => {
      const seen = new Map();
      for (const option of [...select.options]) {
        const key = option.textContent.trim().toLocaleLowerCase();
        const existing = seen.get(key);
        if (!existing) { seen.set(key, option); continue; }
        if (option.selected && !existing.selected) { existing.remove(); seen.set(key, option); }
        else option.remove();
      }
      if (!select.hasAttribute('aria-label')) select.setAttribute('aria-label', select.options[0]?.textContent || '');
    });
    document.querySelectorAll('[data-frm-search]').forEach(form => {
      const input = form.querySelector('[name="q"]');
      const label = input?.placeholder;
      if (!label) return;
      if (!input.hasAttribute('aria-label')) input.setAttribute('aria-label', label);
      const button = form.querySelector('button[type="submit"]');
      if (button && !button.hasAttribute('aria-label')) button.setAttribute('aria-label', label);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, {once:true});
  else enhance();
  document.addEventListener('shopify:section:load', enhance);
})();